export const site = (axios) => ({
  fetchSiteCommon: () => {
    return axios.get('/api/common_sites')
  },
})
